import { FC } from 'lib/component-utils'
import { I18nProvider, SupportedLocale, LocaleData } from 'lib/i18n-client'

interface I18nContextProps {
  locale: SupportedLocale
  messages: LocaleData
  children: React.ReactNode
}

const I18nContext: FC<I18nContextProps> = ({ locale, messages, children }) => {
  return (
    <I18nProvider locale={locale} messages={messages}>
      {children}
    </I18nProvider>
  )
}

export default I18nContext
